/* eslint-disable max-lines-per-function */

import { VisitHistoryDiagnosis } from '@dreryk/egabinet-visit-frontend-api';

import { Table } from '@dreryk/react-components';

import {
   useVisitHistoryDiagnosisColumnsConfiguration,
   useVisitHistoryDiagnosisDataConfiguration,
} from './VisitHistoryDiagnosisTable.hooks';

type VisitHistoryDiagnosisTableProps = {
   readonly diagnoses: VisitHistoryDiagnosis[];
};

export const VisitHistoryDiagnosisTable = (props: VisitHistoryDiagnosisTableProps): JSX.Element => {
   return (
      <Table
         testId={'diagnosis'}
         dataConfiguration={useVisitHistoryDiagnosisDataConfiguration(props.diagnoses)}
         columns={useVisitHistoryDiagnosisColumnsConfiguration()}
         keyExtractor={'icd10Code'}
         pageSize={1000}
         compact
      />
   );
};
